(function () {
    const inFlight = new Map();
    const post = async (path, body, token) => {
        const response = await fetch('/analytics/experiments/' + path, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': token },
            body: JSON.stringify(body), signal: AbortSignal.timeout(4000),
        });
        if (!response.ok) throw new Error('Experiment unavailable');
        return response.status === 204 ? null : response.json();
    };
    window.tokchartExperiments = {
        async render(flag, renderVariant) {
            if (inFlight.has(flag)) return inFlight.get(flag);
            const task = (async () => {
                let rendered = false;
                try {
                    const ph = window.posthog;
                    if (!ph?.__loaded || ph.has_opted_out_capturing()) throw new Error('Analytics unavailable');
                    const response = await fetch('/analytics/experiments/context', {
                        credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(3000),
                        headers: { 'Accept': 'application/json' },
                    });
                    if (!response.ok) throw new Error('Context unavailable');
                    const context = await response.json();
                    if (!context.enabled) throw new Error('Experiments disabled');
                    if (context.distinct_id) {
                        ph.identify(context.distinct_id);
                    } else if (String(ph.get_distinct_id()).startsWith('user:')) {
                        ph.reset();
                    }
                    const assignment = await post('assign', {
                        flag, anonymous_id: context.distinct_id ? null : ph.get_distinct_id(),
                    }, context.csrf_token);
                    if (!assignment) throw new Error('Assignment unavailable');
                    if (ph.has_opted_out_capturing()) throw new Error('Analytics disabled');
                    await renderVariant(assignment.variant);
                    rendered = true;
                    await post('exposed', { flag }, context.csrf_token);
                    return assignment.variant;
                } catch (_) {
                    if (!rendered) await renderVariant('control');
                    return null;
                }
            })();
            inFlight.set(flag, task);
            return task;
        },
    };
})();
